import React, { ReactElement } from 'react';
import styles from './index.module.scss';

export default function OffsetAnchor(props: { id: string }): ReactElement {
  return <span id={props.id} className={styles.anchor} />;
}
